import React from "react";
import { useTranslations } from "@adsk/acc-issues-translations";
import { Formik } from "formik";
import Panel from "@adsk/alloy-react-panel";
import Button from "@adsk/alloy-react-button";

import { IssueFormAttributes } from "@adsk/acc-issues-core/utils/types/Issue";
import { useIssueValidationSchema } from "../utils/validation/entitySchemas";
import { IssueCreationForm } from "./IssueCreationForm";
import { IssueStandardFieldIds } from "@adsk/acc-issues-types";

export interface IssueCreationPanelProps {
  onClose: () => void;
  onSubmit: (attributes: IssueFormAttributes) => Promise<any>;
  initialValues: IssueFormAttributes;
  panelTitle?: string;
  titleFieldLabel?: string;
  requireTitleField?: boolean;
  hideStatusField?: boolean;
  hiddenStandardFields?: Array<keyof IssueStandardFieldIds>;
}

export const IssueCreationPanel = ({
  onClose,
  onSubmit,
  initialValues,
  panelTitle,
  titleFieldLabel,
  requireTitleField = true,
  hideStatusField,
  hiddenStandardFields,
}: IssueCreationPanelProps) => {
  const { T } = useTranslations();

  const validationSchema = useIssueValidationSchema({ requireTitleField });

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ handleSubmit }) => {
          return (
            <div>
              <Panel
                open={true}
                title={panelTitle || T.translate("issueCreation.modalTitle")}
                onClose={onClose}
                width={"100%"}
                renderFooter={() => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "16px 24px",
                      }}
                    >
                      <Button
                        variant={Button.VARIANTS.TERTIARY}
                        onClick={onClose}
                      >
                        {T.translate("actions.cancel")}
                      </Button>
                      <Button
                        variant={Button.VARIANTS.PRIMARY}
                        style={{ marginLeft: 16 }}
                        onClick={() => handleSubmit()}
                      >
                        {T.translate("actions.create")}
                      </Button>
                    </div>
                  );
                }}
              >
                <Panel.Body
                  style={{
                    padding: "0px 24px 16px",
                  }}
                >
                  <IssueCreationForm
                    titleFieldLabel={titleFieldLabel}
                    requireTitleField={requireTitleField}
                    hideStatusField={hideStatusField}
                    hiddenStandardFields={hiddenStandardFields}
                  />
                </Panel.Body>
              </Panel>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};
